import React, { useRef, useEffect } from 'react';
import { StyledHeroIndustries } from './StyledHeroIndustries';
import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useSelector } from "react-redux";


gsap.registerPlugin(ScrollTrigger);

const HeroIndustries = ({ title, img, bgColor }) => {
  const titleRef = useRef(null);
  const heroRef = useRef(null);
  const imgRef = useRef(null);
  
  const loader = useSelector((state) => state.loader);

  useEffect(() => {
    let vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);
    
    if(window.innerWidth >= 768)
      gsap.to(titleRef.current, {
        y: '-150px',
        ease: "none",
        scrollTrigger: {
          trigger: titleRef.current,
          start: "top 40%", 
          end: "+=100%",
          scrub: 1
        }
      });
  },[])


  const transitionIn = () => {
    gsap.to(heroRef.current, {width: "100%", top: 16, duration: 2, ease: "expo.easeInOut"})
    gsap.to(titleRef.current, {color: "#fff", left: 0, duration: 1.5, delay: .5, ease: "expo.easeInOut"})
    gsap.to(imgRef.current, {right: 0, x: 0 , width: "66.66%", delay: .15, duration: 1.5, delay: .5, ease: "expo.easeInOut"})
  }
  useEffect(()=>{

    if(!loader.isLoading && window.innerWidth >= 768){
    
      setTimeout(() => transitionIn(), 1500)
    }
  }, [loader])

  return (
    <React.Fragment>
      {
       
          <StyledHeroIndustries>
            <div ref={heroRef} className="industries--hero-bg" style={{background: bgColor}}></div>
            <h4 ref={titleRef} className="md--title">{title}</h4> 
            <img ref={imgRef}  src={img} />
          </StyledHeroIndustries>
          
      }
    </React.Fragment>
  );
};


export default HeroIndustries;
